var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 27.9545C6 28.5191 6.47045 29 7.04545 29H20.6364C21.2218 29 21.6818 28.5191 21.6818 27.9545V27.1674H6V27.9545ZM13.8409 14.3636C9.92045 14.3636 6 16.4545 6 20.6364H21.6818C21.6818 16.4545 17.7614 14.3636 13.8409 14.3636ZM8 19C8.5 17 11.0794 15.9221 13.8409 15.9221C17 16 19 17 20 19H8ZM6 23.1675H21.6818V24.8182H6V23.1675ZM23.7727 10.1818V6H22V10.1818H16.4545L17 12H27L25.5 27H23.7727V29H25.5709C26.4491 29 27.1705 28.3205 27.275 27.4632L29 10.1818H23.7727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/Meal.4ecd7a3754c4789c0f688dfb9b3f6b0d.svg";
export { ForwardRef as ReactComponent };